import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions } from 'vuex';
import { required, minLength } from 'vuelidate/lib/validators';
import { stepForm } from '~/mixins';

export default {
    mixins: [stepForm],
    data: function data() {
        var _$store$state$affilia = this.$store.state.affiliations.form.businessSchedule,
            startTime = _$store$state$affilia.startTime,
            endTime = _$store$state$affilia.endTime,
            schedule = _$store$state$affilia.schedule;

        return {
            days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            toggle_multiple: schedule,
            start: startTime || null,
            final: endTime || null,
            timepickers: [{
                time: null,
                modal: false,
                color: 'input__blue'
            }, {
                time: null,
                modal: false,
                color: 'input__yellow'
            }],
            conditional: true,
            sending: false
        };
    },

    validations: {
        start: { required: required },
        final: { required: required },
        toggle_multiple: { required: required }
    },
    computed: {
        arrayNew: function arrayNew() {
            var arrayNew = [-1, -1, -1, -1, -1, -1, -1];
            this.toggle_multiple.forEach(function (i) {
                arrayNew[i] = i;
            });
            return arrayNew;
        }
    },
    methods: {
        submit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$v.$touch();

                                if (!this.$v.$invalid) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:

                                this.sending = true;
                                _context.prev = 4;
                                _context.next = 7;
                                return this.$store.dispatch("affiliations/form/saveBusinessSchedule", {
                                    startTime: this.start,
                                    endTime: this.final,
                                    schedule: this.arrayNew,
                                    initDay: '0900AM',
                                    endDay: '0500PM'
                                });

                            case 7:
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](4);

                                this.$controlMessage(_context.t0);

                            case 12:
                                this.sending = false;

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 9]]);
            }));

            function submit() {
                return _ref.apply(this, arguments);
            }

            return submit;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/business-schedule.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/business-schedule.vue
// module chunks = 0 1 2 3